import { RouterProvider } from 'react-router-dom';

import AuthProviderV2 from './providers/AuthProviderV2';
import QueryClientProvider from './providers/QueryClientProvider';
import ThemeProvider from './providers/ThemeProvider';
import router from './routes';

import 'src/shared/styles/global.css';

export const App = () => {
  return (
    <QueryClientProvider>
      <AuthProviderV2>
        <ThemeProvider>
          <main className="bg-white min-h-dvh v2-global">
            <RouterProvider router={router} />
          </main>
        </ThemeProvider>
      </AuthProviderV2>
    </QueryClientProvider>
  );
};

export default App;
